module.exports = __webpack_public_path__ + "static/media/Deploy fleets.c116817c.png";